import { MenuItem } from 'primeng/api';
import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MenuService {
  private menu = new BehaviorSubject<string[]>([]);

  get getMenu() {
    return this.menu.asObservable();
 }

  nextMenu(value: string[]) {
    this.menu.next(value);
  }

}
